// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type { AgentPoolsOperations } from "./agentPools/index.js";
export type { MachinesOperations } from "./machines/index.js";
export type { MaintenanceConfigurationsOperations } from "./maintenanceConfigurations/index.js";
export type { ManagedClustersOperations } from "./managedClusters/index.js";
export type { ManagedNamespacesOperations } from "./managedNamespaces/index.js";
export type { OperationsOperations } from "./operations/index.js";
export type { PrivateEndpointConnectionsOperations } from "./privateEndpointConnections/index.js";
export type { PrivateLinkResourcesOperations } from "./privateLinkResources/index.js";
export type { ResolvePrivateLinkServiceIdOperations } from "./resolvePrivateLinkServiceId/index.js";
export type { SnapshotsOperations } from "./snapshots/index.js";
export type { TrustedAccessRoleBindingsOperations } from "./trustedAccessRoleBindings/index.js";
export type { TrustedAccessRolesOperations } from "./trustedAccessRoles/index.js";
